export const MSG_CONST = {
    FILE_ERROR: 'please uplode file',
    COMMON_ERROR: 'Something went wrong',
    SERVER_ERROR: 'Unable to connect the server',
    FIREBASE_NO_TOKEN: 'No registration token available. Request permission to generate one.',
    SUBSCRIBE_SUCCESS: 'You have successfully subscribed the Push Notification',
    UNSUBSCRIBE_SUCCESS: 'You have successfully Unsubscribed the Push Notification.',
    UNSUBSCRIBE_FAILED: 'Unable to Unsubscribe the Web Push notification.',
    NO_RESPONSES: 'No responses',
    ASSIGNED_RESPONSES: 'No responses are assigned to you',
    FOLLOWED_RESPONSES: 'No responses are followed to you',
    UNREAD_RESPONSES: 'No unread responses',
    NO_MORE_LOAD: 'No more data left to load',
    LOAD_MORE: 'Load more',
    QUICK_INSIGHTS_TOP_3_INTERACTION_SUB_CATEGORY: 'Top 3 Interaction Sub-Category',
    QUICK_INSIGHTS_BOTTOM_3_INTERACTION_SUB_CATEGORY: 'Bottom 3 Interaction Sub-Category',
    QUICK_INSIGHTS_TOP_3_PERFORMER: 'Top 3 Performers',
    QUICK_INSIGHTS_BOTTOM_3_PERFORMER: 'Bottom 3 Performers',
    SELECTED_LEVEL_TYPE: 'Comparison',
    VIEW_BY: 'View By',
    PASSWORD_EXPIRED: 'Password Expired: For security reasons, your password needs to be changed.',
    DELETED_OPTION_TOOLTIP: 'This option has been deleted and is not part of the current conversation version.'
}